module.exports = __webpack_public_path__ + "static/media/picked-active.0ee85a80.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/picked-active.svg
// module id = ./src/assets/icons/picked-active.svg
// module chunks = 0